<template>
  <div>
    <div class="home-product">
      <div class="home-pro-title">
        <div class="pro-title-left">
          <svg-icon icon-class="home_pro_line"></svg-icon>
          <span>产品</span>
        </div>
        <div class="pro-title-right" @click.prevent="moreProduct">
          <span>更多</span>
          <svg-icon icon-class="home_pro_more"></svg-icon>
        </div>
      </div>
      <div class="home-pro-img">
<!--        <van-tabs type="card" v-model="active">-->
<!--          <van-tab-->
<!--            :title="item.name"-->
<!--            v-for="(item, index) in productList"-->
<!--            :key="index"-->
<!--            :name="item.name"-->
<!--          >-->
<!--            <van-swipe :loop="false" :width="116" touchable :show-indicators="false">-->
<!--              <van-swipe-item v-for="(it,ind) in item.value" :key="ind">-->
<!--                <div class="swipe-img">-->
<!--                  <img :src="it.img" @click.prevent="checkImg(it)" />-->
<!--                </div>-->
<!--              </van-swipe-item>-->
<!--            </van-swipe>-->
<!--          </van-tab>-->
<!--        </van-tabs>-->
        <!--        <van-tabs type="card" v-model="active">-->
        <!--          <van-tab-->
        <!--            :title="item.name"-->
        <!--            v-for="(item, index) in productList"-->
        <!--            :key="index"-->
        <!--            :name="item.name"-->
        <!--          >-->
        <!--            <van-swipe :loop="false" :width="116" touchable :show-indicators="false">-->
        <!--              <van-swipe-item v-for="(it,ind) in item.value" :key="ind">-->
        <!--                <div class="swipe-img">-->
        <!--                  <img :src="it.img" @click.prevent="checkImg(it)" />-->
        <!--                </div>-->
        <!--              </van-swipe-item>-->
        <!--            </van-swipe>-->
        <!--          </van-tab>-->
        <!--        </van-tabs>-->
        <van-swipe :loop="false" :width="116" touchable :show-indicators="false">
          <van-swipe-item v-for="(it,ind) in productList[0].value" :key="ind">
            <div class="swipe-img">
              <img :src="it.img" @click.prevent="checkImg(it)" />
            </div>
          </van-swipe-item>
        </van-swipe>

      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
import { setSession, setLocal } from "@/utils/utils";
import { Toast } from "vant";
export default {
  data() {
    return {
      productList: [
        // {value:[
        //     {img:require('./img/swipe1.png')}
        // ]}
      ],
      active: '1',
    }
  },
  mounted() {
    this.fatchdata()
  },
  methods: {
    moreProduct() {
      this.$router.push('/productList')
    },
    fatchdata() {
      // Toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   forbidClick: true
      // });
      this.$fetchGet(URL.findplist.url, { flag: 0, createCompany: 'ZFKJ' }).then(res => {
        Toast.clear();
        if (res.data) {
          //data是“全部”，“贷款”，“保险”，“教育”4中类型，截取贷款数据处理
          this.productList = res.data.slice(1,2);
        }

      })
    },
    checkImg(v) {
      setLocal('img', v.img)
      setLocal('Qimg', v.qrCode)
      setLocal('Simg', v.consultCode)
      setLocal('productId', v.id)
      this.$router.push({ path: '/showBusiness', query: { id: v.id } })
    },
  },
}
</script>

<style lang="less" scoped>
.home-product {
  width: 375px;
  height: 163px;
  margin-top: 10px;
  // padding-bottom: 18.5px;
  margin-bottom: 10px;
  background: #fff;
  overflow: hidden;
  .home-pro-title {
    width: 345px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pro-title-left {
    display: flex;
    align-items: center;
    .svg-icon {
      width: 2px;
      height: 13px;
    }
    span {
      padding-left: 14px;
      font-size: 15px;
      font-weight: Bold;
      font-family: "PingFang SC";
      color: #333333;
    }
  }
  .pro-title-right {
    display: flex;
    align-items: center;
    span {
      display: flex;
      padding-right: 7px;
      font-size: 13px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #666666;
    }
    .svg-icon {
      width: 4.73px;
      height: 5.4px;
    }
  }
  .home-pro-img {
    width: 345px;
    margin: 11.5px auto 0 auto;
    .van-swipe {
      margin-top: 16px;
    }
    /deep/ .van-tabs__nav--card .van-tab {
      //   border: 0;
      border-right: 0.5px solid #ededed;
    }
    /deep/ .van-tabs__nav--card .van-tab:last-child {
      //   border: 0;
      border-right: 0;
    }
    /deep/ .van-tabs__nav--card {
      width: 100%;
      padding: 0;
      margin: 0;
      border: 0;
    }
    /deep/.van-tabs__wrap {
      height: 33px;
    }
    /deep/.van-tabs__nav--card .van-tab.van-tab--active {
      font-size: 14px;
      font-weight: bold;
      font-family: PingFang SC;
      color: #FC6E09;
      background: url("../../assets/publicImg/li-bg4.png") no-repeat 100%;
      background-size: 100% 100%;
      //   border: 1px solid;
      width: 115px;
      height: 33px;
    }
    /deep/.van-tabs__nav--card .van-tab {
      font-size: 14px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #333333;
      background: url("../../assets/publicImg/li-bg7.png") no-repeat;
      background-size: 100% 100%;
      //   border: 1px solid;
      width: 115px;
      height: 33px;
    }
    .swipe-img {
      img {
        width: 96px;
        height: 137px;
      }
    }
  }
  //   .van-swipe-item:not(:first-child){
  //       margin-left: 10px;
  //   }
}
</style>